(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  const stickyHeader = document.querySelector('sticky-header');
  if(!stickyHeader || stickyHeader == null){ 
    document.documentElement.style.setProperty('--header-height', `0px`);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponsored-players"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sponsored-players')) return;

    var LOCK_CLASS = 'player-popup-open';

    function unlockPage() {
      if (!document.querySelector('dialog.player-popup[open]')) {
        document.documentElement.classList.remove(LOCK_CLASS);
      }
    }

    function openPopup(dialog) {
      if (!dialog || dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add(LOCK_CLASS);
    }

    function closePopup(dialog) {
      if (!dialog || !dialog.open) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      unlockPage();
    }

    class SponsoredPlayers extends HTMLElement {
      constructor() {
        super();
        this.pressTarget = null;
        this.onClick = this.onClick.bind(this);
        this.onPress = this.onPress.bind(this);
        this.onClose = this.onClose.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPress);
        // "close" does not bubble, so listen in the capture phase
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPress);
        this.removeEventListener('close', this.onClose, true);
        this.querySelectorAll('dialog.player-popup[open]').forEach(closePopup);
        unlockPage();
      }

      onPress(event) {
        this.pressTarget = event.target;
      }

      onClick(event) {
        var opener = event.target.closest('[data-player-open]');
        if (opener) {
          openPopup(document.getElementById(opener.getAttribute('data-player-open')));
          return;
        }

        if (event.target.closest('[data-player-close]')) {
          closePopup(event.target.closest('dialog.player-popup'));
          return;
        }

        // A click on the backdrop reports the dialog itself as the target.
        // Ignore it when the press started inside the pop-up (e.g. selecting text).
        if (
          event.target.matches &&
          event.target.matches('dialog.player-popup') &&
          this.pressTarget === event.target
        ) {
          closePopup(event.target);
        }
      }

      onClose() {
        unlockPage();
      }
    }

    customElements.define('sponsored-players', SponsoredPlayers);

    // Theme editor: show the pop-up while one of its blocks is selected,
    // so block changes and reordering can be previewed.
    document.addEventListener('shopify:block:select', function (event) {
      var dialog = event.target.closest && event.target.closest('dialog.player-popup');
      if (!dialog) return;
      openPopup(dialog);
      event.target.scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var dialog = event.target.closest && event.target.closest('dialog.player-popup');
      closePopup(dialog);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      event.target.querySelectorAll('dialog.player-popup[open]').forEach(closePopup);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
